/**
 * Sanitises a raw time string from a parsed timetable.
 * Returns null if the value represents an unknown/overnight time (e.g. "….", "...").
 * Returns the trimmed time string if valid.
 */
export function sanitiseTime(value: string): string | null {
  if (!value || /^[\s\.…\u2026]+$/.test(value.trim())) return null;
  return value.trim();
}
